import isEmpty from 'lodash/isEmpty';
import type { IResponse } from '../../entities/Response';

export default function SourceInterpreter(response: IResponse) : Object<any> | Array<any> {
  const emptySource = isEmpty(response.source);
  const data = !emptySource ? response.source.data : response.messages;

  return data;
}
